// Third Party Libraries Imports
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

// Local Imports
import { LOADING, UPDATE_FAVOURITE_LIST } from "../../store/actions";
import instance from "../../store/axios";
import FavouriteMenu from "../../models/favourite-menu.model";
import { AxiosResponse } from "axios";

export default class SidebarService {
  private dispatch = useDispatch();
  private user = useSelector((state: any) => state.user);

  public async addToFavouriteList(name: string, url: string): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{ data: FavouriteMenu; message: string }> =
        await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/favorite-list`, { name, url });
      this.user?.favoriteList?.push({
        id: response?.data.data?.id,
        name: response?.data?.data?.name,
        url: response?.data?.data?.url,
      });
      this.dispatch({
        type: UPDATE_FAVOURITE_LIST,
        payload: this.user?.favoriteList,
      });

      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async removeFromFavouriteList(itemId: number): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}favorite-list/${itemId}/delete`, {
        favoriteItemId: itemId,
      });

      this.dispatch({
        type: UPDATE_FAVOURITE_LIST,
        payload: this.user?.favoriteList?.filter(
          (item: FavouriteMenu) => item.id !== itemId
        ),
      });
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}
